import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="keyframe, rhombus" maskId="round-filled-radius-0-stroke-1.5-IconKeyframe"><path d="M12.5303 1.71967C12.2374 1.42678 11.7626 1.42678 11.4697 1.71967L1.71967 11.4696C1.57902 11.6103 1.5 11.801 1.5 12C1.5 12.1989 1.57902 12.3896 1.71967 12.5303L11.4697 22.2803C11.6103 22.421 11.8011 22.5 12 22.5C12.1989 22.5 12.3897 22.421 12.5303 22.2803L22.2803 12.5303C22.421 12.3896 22.5 12.1989 22.5 12C22.5 11.801 22.421 11.6103 22.2803 11.4696L12.5303 1.71967Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyframe;
